import {
  PriorityLevel,
  UrgencyLevel,
  ComplexityLevel,
} from '../../../Priority/types';
import PriorityCell from '../PriorityColumn/PriorityCell';
import { formatAge } from '../../../../helpers';

export const placeholderFormatter = (cell, row) => {
  if (row) {
    return (
      <>
        <p>
          <div>-</div>
        </p>
      </>
    );
  }
};

export const priorityFormatter = (cell, row) => {
  // TODO: to be removed, this function generate test data only
  const getRandomCombination = () => {
    const getRandomValue = (obj) => {
      const values = Object.values(obj);
      const randomIndex = Math.floor(Math.random() * values.length);
      return values[randomIndex];
    };

    return {
      priority: getRandomValue(PriorityLevel),
      urgency: getRandomValue(UrgencyLevel),
      complexity: getRandomValue(ComplexityLevel),
    };
  };
  const { priority, urgency, complexity } = getRandomCombination();
  return (
    <div key={`priority-${row.id}`} className="right-text">
      <PriorityCell
        id={row.id}
        priorityLevel={priority}
        urgency={urgency}
        complexity={complexity}
      />
    </div>
  );
};

export const nameAgeURFormatter = (cell, row) => {
  if (row) {
    return (
      <>
        <p>
          <div>{row.first_name + ' ' + row.last_name}</div>
          <div className="font-11">
            {formatAge(row.dob)}
            {row.client_no && ', ' + row.client_no}
          </div>
        </p>
      </>
    );
  }
};

export const nameURFormatter = (cell, row) => {
  if (row) {
    return (
      <>
        <p>
          <div>{row.first_name + ' ' + row.last_name}</div>
          <div className="font-11">{row.client_no}</div>
        </p>
      </>
    );
  }
};
